import {Component, Input} from '@angular/core'
import {defineLocale} from 'ngx-bootstrap/chronos'
import {enGbLocale} from 'ngx-bootstrap/locale'

defineLocale('en-gb', enGbLocale)

import {Router} from '@angular/router'
import {BreadcrumbService} from './breadcrumbs.service'
import {Observable} from 'rxjs'

export interface Breadcrumb {
  label: string
  url: string
}

@Component({
  selector: 'breadcrumb',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
  standalone: false,
})
export class BreadcrumbsComponent {
  @Input() useBootstrap: boolean = true
  @Input() prefix: string = ''

  breadcrumbs$: Observable<Breadcrumb[]>

  constructor(
    private breadcrumbService: BreadcrumbService,
    private router: Router,
  ) {
    this.breadcrumbs$ = breadcrumbService.breadcrumbs$
  }

  navigateTo(url: string): void {
    this.router.navigateByUrl(url)
  }
}
